import { render, staticRenderFns } from "./venueSelect.vue?vue&type=template&id=2def3a98&scoped=true&"
import script from "./venueSelect.vue?vue&type=script&lang=js&"
export * from "./venueSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2def3a98",
  null
  
)

export default component.exports